<template>
  <div v-if="isEmpty" class="settings__empty">
    <v-img :src="SettingsPlaceholder" width="160px" class="mb-6" />
    <div class="caption mb-6">Настройте варианты размещения тарифного плана</div>
    <operation-button
      :operation="activeTariff?.operations?.startPVM"
      prepend-icon-src="wand"
      :loading="isPVMStartLoading"
      variant="primary"
      @click="startPVM"
    >
      Мастер вариантов размещения
    </operation-button>
  </div>

  <tabs-list v-else :tabs="tabs">
    <template #append>
      <div class="d-flex align-center justify-space-between master-actions">
        <div :id="tariffTabsAppendTeleport" v-show="activeTabIndex === 2" class="mr-6" />
        <operation-button
          prepend-icon-src="wand"
          variant="link"
          class="pb-md-4"
          :operation="activeTariff?.operations?.startPVM"
          :loading="isPVMStartLoading"
          @click="startPVM"
        >
          Перезапустить мастер
        </operation-button>
      </div>
    </template>
    <template v-slot:[`tab.categories`]>
      <room-categories />
    </template>
    <template v-slot:[`tab.type`]>
      <tourists-types />
    </template>
    <template v-slot:[`tab.variants`]>
      <placing-variants />
    </template>
  </tabs-list>
</template>

<script setup lang="ts">
import { ref, toRef, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import SettingsPlaceholder from '@/assets/img/pages/tariffs/settings-placeholder.svg';
import OperationButton from '@/core/components/buttons/OperationButton.vue';
import TabsList from '@/core/components/interface/Tabs.vue';
import { tariffTabsAppendTeleport } from '@/core/consts/teleport';
import { RouteNames } from '@/core/plugins/router/routeNames';
import PlacingVariants from '@/parts/tariffs/components/PlacingVariants.vue';
import RoomCategories from '@/parts/tariffs/components/RoomCategories.vue';
import TouristsTypes from '@/parts/tariffs/components/TouristsTypes.vue';
import { useTariffsStore } from '@/parts/tariffs/store/tariffs';

const { activeTariff, startPlacingVariantsMaster } = useTariffsStore();
const $router = useRouter();
const $route = useRoute();

const isPVMStartLoading = ref(false);

const activeTabIndex = computed(() => Number($route.query.tab) || 0);

const startPVM = async () => {
  isPVMStartLoading.value = true;

  const result = await startPlacingVariantsMaster();

  if (result && !result.errors) {
    $router.push({
      name: RouteNames.TariffPlacingVariantsMaster,
      params: { id: $route.params.id, acc_id: $route.params.acc_id },
    });
  }

  isPVMStartLoading.value = false;
};

const isEmpty = toRef(() => activeTariff.value && !activeTariff.value.baseSettings?.completed);

const tabs = [
  {
    title: 'Категории номеров',
    key: 'categories',
  },
  {
    title: 'Типы туристов',
    key: 'type',
  },
  {
    title: 'Варианты размещения',
    key: 'variants',
  },
];
</script>

<style scoped lang="scss">
.settings {
  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;

    max-width: 600px;
    margin: 140px auto 0;

    text-align: center;
  }
}

.master-actions {
  @include sm-and-down {
    justify-content: flex-start !important;
  }
}
</style>
